<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.tbf">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Titanium Dioxide</span>
        </b>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">
            <br>
          </span>
        </b>
      </p>
      <p style="text-align:left;" align="left">
        <b>
          <span style="font-size:12px;font-family:Arial;">Commodity:</span>
        </b>
        <span style="font-size:12px;font-family:Arial;color:black;">Titanium Dioxide</span>
        <b>
          <span style="font-size:12.0pt;font-family:Arial;"></span>
        </b>
      </p>
      <p style="text-align:left;" align="left">
        <b>
          <span style="font-size:12px;font-family:Arial;">Grade:</span>
        </b>
        <span style="font-size:12px;font-family:Arial;">Rutile</span>
      </p>
      <p style="text-align:left;" align="left">
        <b>
          <span style="font-size:12px;font-family:Arial;">Spec:</span>
        </b>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">
          <span style="font-size:12px;">TiO2 content (m/m):</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">93.0%min</span>
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">
          <span style="font-size:12px;">Rutile crystal content:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">97.0%min</span>
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">
          <span style="font-size:12px;">
            Volatile constituents at 105℃
            (m/m) :
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">0.5%max</span>
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">
          <span style="font-size:12px;">Resistivity (Ω/m):</span>
          <span style="font-size:12px;">&nbsp;&nbsp;</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">80min</span>
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">
          <span style="font-size:12px;">Residue on sieve of 45 μm (m/m):</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">0.05%max</span>
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">
          <span style="font-size:12px;">PH Value:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">6.0-8.5</span>
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">
          <span style="font-size:12px;">Tinctorial power(compared with standard sample):</span>
          <span></span>
          <span style="font-size:12px;">105min</span>
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:black;">
          <span style="font-size:12px;">Oil Absorption (g/100g):</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">1.0max</span>
        </span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.lsn">
      </p>
      <p>
        <b style="line-height:1.5;">
          <span style="font-size:18px;font-family:宋体;">Anhydrous Sodium Carbonate</span>
        </b>
      </p>
      <p>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">
          Name
          of Commodity: Anhydrous Sodium Carbonate
        </span>
      </p>
      <p>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >Specification:</span>
      </p>
      <p>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">Assay</span>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">Min 99.5%</span>
      </p>
      <p>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">Boron (B)</span>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">
          Max 0.3 ppm, best
          efforts 0.25 ppm max
        </span>
      </p>
      <p>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >Phosphorus (P)</span>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >&nbsp;&nbsp;</span>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >Max 4 ppm; best efforts 3 ppm max.</span>
      </p>
      <p>
        <span style="font-family:Arial;font-size:12pt;text-indent:22.2pt;line-height:1.5;">
          <span style="font-size:12px;"></span>
          <span style="font-size:12px;">Loss on Heating at 285 *C</span>
        </span>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">&nbsp;</span>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">Max 1.0%</span>
      </p>
      <p>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >Insoluble Matter</span>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">&nbsp;</span>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">Max 0.01%</span>
      </p>
      <p>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >Heavy Metals (as Pb)</span>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">&nbsp;</span>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">
          Max
          5 ppm
        </span>
      </p>
      <p>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">Iron (Fe)</span>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span style="font-family:Arial;font-size:12pt;text-indent:22.2pt;line-height:1.5;"></span>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span
          style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;"
        >&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span style="font-family:Arial;font-size:12px;text-indent:22.2pt;line-height:1.5;">
          Max
          4 ppm
        </span>
      </p>
      <p>
        <span style="font-family:Arial;font-size:12px;text-indent:48pt;line-height:1.5;">Size</span>
        <span
          style="font-family:Arial;font-size:12px;text-indent:48pt;line-height:1.5;"
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span style="font-family:Arial;font-size:12px;text-indent:48pt;line-height:1.5;">20-100mesh</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        tbf: require("../../../assets/img/common/tbf.jpg"),
        lsn: require("../../../assets/img/common/lsn.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/hgyl.vue